<script setup>
import { Icon, Button } from "@components";
import { ref, computed, onMounted } from "vue";
import { useSettings } from "@store/settings";
const $settings = useSettings();

import { useAppointment } from "@store/appointment";
const $appointment = useAppointment();

import { useService } from "@store/service";
const $service = useService();

import { sortedDays } from "@utils";
import moment from "moment";

const emit = defineEmits(["update:date", "change"]);

const props = defineProps({
	date: {
		type: String,
	},
	// start: {
	//     type: String,
	//     default: ''
	// },
	// end: {
	//     type: String,
	//     default: ''
	// },
	serviceId: {
		type: Number,
		default: 0,
	},
	staffId: {
		type: Number,
		default: 0,
	},
});

const isOpen = ref(false);
const currentMonth = ref(moment().month());
const currentYear = ref(moment().year());

const currentRange = computed(() =>
	moment().set("month", currentMonth.value).set("year", currentYear.value)
);

const getDays = computed(() => {
	let days = [];

	const firstDayOfWeek = $settings.getSettings.calendar.first_day || "Sunday";

	// start date; if current month doesn't start with firstDayOfWeek, then we need to go back to the previous month's last firstDayOfWeek
	let startDate = moment()
		.set("month", currentMonth.value)
		.set("year", currentYear.value)
		.startOf("month");
	while (startDate.format("dddd") !== firstDayOfWeek) {
		startDate.subtract(1, "day");
	}

	// Iterate for next 35 days
	for (let i = 0; i < 35; i++) {
		days.push({
			date: startDate.format("D"),
			fullDate: startDate.format("YYYY-MM-DD"),
			isHoliday: $appointment.isHoliday(startDate.format("YYYY-MM-DD")),
			isSelected: startDate.format("YYYY-MM-DD") === props.date,
		});
		startDate.add(1, "day");
	}

	return days;
});

// slots

// const slots = ref([])
// const getSlots = () => {
//     let service = $service.getServiceById(props.serviceId)
//     if (!service) return []

//     const duration = service.meta.duration * (service.meta.duration_unit === 'minute' ? 1 : 60)
//     const hasBuffer = service.meta.hasBuffer || false
//     const preBuffer = hasBuffer ? service.meta.pre_buffer * (service.meta.pre_buffer_unit === 'minute' ? 1 : 60) : 0
//     const postBuffer = hasBuffer ? service.meta.post_buffer * (service.meta.post_buffer_unit === 'minute' ? 1 : 60) : 0

//     const day = moment(props.date, 'YYYY-MM-DD').format('dddd')
//     const businessDay = prebook_admin.settings.business_hours[day] || { enabled: false }

//     if (!businessDay.enabled) return []
//     console.log('booking_date', props.date, day, businessDay);

//     const slots = []
//     businessDay.hours.forEach(hour => {
//         const start = moment(`${props.date} ${hour.start}`, 'YYYY-MM-DD HH:mm a')
//         const end = moment(`${props.date} ${hour.end}`, 'YYYY-MM-DD HH:mm a')

//         while (start.isSameOrBefore(end)) {
//             const slot = {
//                 start: start.format('HH:mm'),
//                 end: start.add(duration, 'minutes').format('HH:mm')
//             }

//             if (hasBuffer) {
//                 slot.start = moment(`${props.date} ${slot.start}`, 'YYYY-MM-DD HH:mm').subtract(preBuffer, 'minutes').format('HH:mm')
//                 slot.end = moment(`${props.date} ${slot.end}`, 'YYYY-MM-DD HH:mm').add(postBuffer, 'minutes').format('HH:mm')
//             }

//             // Continue if the slot.end exceeds end time
//             if (moment(`${props.date} ${slot.end}`, 'YYYY-MM-DD HH:mm').isAfter(end)) {
//                 continue
//             }

//             // Add label
//             slot.label = `${moment(slot.start, 'HH:mm').format('hh:mm A')} - ${moment(slot.end, 'HH:mm').format('hh:mm A')}`

//             // Check if the slot is already booked
//             slot.isBooked = false,

//             // If props.start and props.end are same as slot.start and slot.end, then set it as selected
//             slot.isSelected = props.start === slot.start

//             slots.push(slot)
//         }

//     })

//     return slots
// }

const setMonth = (month) => {
	// Handle next, prev month
	if (month === "next") {
		if (currentMonth.value === 11) {
			currentMonth.value = 0;
			currentYear.value++;
		} else {
			currentMonth.value++;
		}
	} else {
		if (currentMonth.value === 0) {
			currentMonth.value = 11;
			currentYear.value--;
		} else {
			currentMonth.value--;
		}
	}
};

const setDate = (fullDate = "") => {
	/**
	 * Note : this code is not working as expected. added date as params
	 */
	// if (fullDate == true) {
	//     fullDate = moment().format('YYYY-MM-DD')
	// } else if (fullDate == false) {
	//     fullDate = ''
	// }

	// Bail if date is not available
	if (fullDate !== "" && $appointment.isHoliday(fullDate)) return;
	console.log("ok", fullDate);
	props.date = fullDate;

	emit("update:date", props.date);
	emit("change", props.date);

	// slots.value = getSlots()

	isOpen.value = false;

	return;
};

// Shift date.
const shiftDate = (direction) => {
	console.log("shiftDate", direction);

	// Shifting props.date based on direction and availability.
	let date = moment(props.date, "YYYY-MM-DD");

	if (direction === "up") {
		date.subtract(7, "days");
	} else if (direction === "down") {
		date.add(7, "days");
	} else if (direction === "left") {
		date.subtract(1, "day");
	} else if (direction === "right") {
		date.add(1, "day");
	}

	// Bail if date is not available
	if ($appointment.isHoliday(date.format("YYYY-MM-DD"))) return;

	props.date = date.format("YYYY-MM-DD");
	emit("update:date", props.date);
	emit("change", props.date);

	// slots.value = getSlots()

	// Adjust the month and year
	currentMonth.value = date.month();
	currentYear.value = date.year();
};

// const setSlot = (slot) => {
//     props.start = slot.start
//     props.end = slot.end

//     emit('update:start', slot.start)
//     emit('update:end', slot.end)
//     emit('change')

//     // isOpen.value = false
// }

// onMounted(() => {
//     slots.value = getSlots()
// })
</script>
<template>
	<div class="relative">
		<!-- visible  -->
		<div tabindex="1" class="border focus:ring ring-purple-200 active:ring border-gray-300 rounded-lg px-5 py-2.5 cursor-pointer hover:bg-slate-50 transition text-sm" :class="{ 'text-gray-500': !props.date }" @click="isOpen = !isOpen">{{ props.date ? moment(props.date, 'YYYY-MM-DD').format("MMM D, YYYY") : 'Select Date' }}</div>
		<!-- modal  -->
		<transition name="fade">
			<div v-if="isOpen">
				<div class="fixed z-40 top-0 left-0 w-full h-full flex items-center justify-center">
					<div class="absolute inset-0 bg-black bg-opacity-30 z-0" @click="isOpen = false"></div>
					<div class="w-fit flex bg-white z-50 shadow-lg rounded-lg border border-slate-300 h-[500px] divide-y divide-gray-400">
						<!-- dates  -->
						<div class="w-[426px] py-8 px-10 flex flex-col gap-5 relative">
							<div class="text-[#344054] text-xl font-semibold text-center">Select Date</div>
							<div class="space-y-3">
								<!-- header -->
								<div class="flex items-center justify-between px-1" :class="{ 'flex-row-reverse': $settings.isRTL }">
									<Icon name="chevronLeft" size="36px" class="p-2 text-[#667085] cursor-pointer hover:bg-gray-50 active:bg-gray-100 transition" @click="setMonth('prev')" />
									<div class="text-[#344054] text-base font-semibold">{{ currentRange.format('MMMM YYYY') }}</div>
									<Icon name="chevronRight" size="36px" class="p-2 text-[#667085] cursor-pointer hover:bg-gray-50 active:bg-gray-100 transition" @click="setMonth('next')" />
								</div>
								<!-- dates  -->
								<div class="grid grid-cols-7 gap-2 last:mb-0 w-full pl-2 outline-none focus:outline-none" tabindex="1" @keydown.up.prevent="shiftDate('up')" @keydown.down.prevent="shiftDate('down')" @keydown.left.prevent="shiftDate('left')" @keydown.right.prevent="shiftDate('right')">
									<div v-for="day in sortedDays()" class="w-10 h-10 text-[#344054] text-sm font-medium flex items-center justify-center">{{ day.slice(0, 3) }}</div>
									<div v-for="(day, index) in getDays" :key="index" @click="setDate(day.fullDate)" @keypress.enter="setDate(day.fullDate)" class="w-10 h-10 flex items-center justify-center text-sm leading-normal rounded-full cursor-pointer" :class="{
                                        'bg-[#7F56D9] text-white': day.isSelected,
                                        'text-[#344054] font-normal hover:bg-[#F9F5FF]': !day.isSelected,
                                        'pointer-events-none opacity-40': day.isHoliday
                                    }">{{ day.date }}</div>
								</div>
								<!-- footer  -->
								<div class="flex items-center gap-4 justify-between">
									<!-- Today button and clear button  -->
									<Button type="secondary_gray" @click.prevent="setDate(moment().format('YYYY-MM-DD'))" class="w-24">Today</Button>
									<Button v-if="props.date" type="secondary_gray" @click.prevent="setDate()" class="w-24">Clear</Button>
								</div>
							</div>
						</div>
						<!-- slots  -->
						<!-- <div v-if="slots.length > 0" class="w-[380px] py-8 pl-0 px-10 flex flex-col gap-5">
                            <div class="text-[#344054] text-xl font-semibold text-center">Select Slot</div>
                            <div
                                v-if="slots.length > 0"
                                class="rounded-lg grid grid-cols-2 gap-3 w-full h-full overflow-y-scroll scrollbar-thin scrollbar-corner-primary-600 scrollbar-track-gray-400 scrollbar-thumb-primary-600">
                                <div v-for="(slot, index) in slots" :key="index" @click="setSlot(slot)"
                                    class="h-12 flex items-center justify-center whitespace-nowrap px-3 rounded-lg cursor-pointer hover:bg-gray-50 border border-gray-200 hover:shadow transition text-[13px] font-medium tracking-wide text-center"
                                    :class="{ 'bg-primary-600 text-white hover:bg-primary-600 hover:opacity-90': slot.isSelected }"> {{ slot.label }} </div>
                            </div>

                            <div v-else class="text-[#344054] text-sm font-normal text-center p-5">
                                Please select a date to view available slots.
                            </div>
						</div>-->
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>